import FroalaEditor from "froala-editor";
import "froala-editor/js/plugins/align.min.js";
import "froala-editor/js/plugins/char_counter.min.js";
import "froala-editor/js/plugins/code_view.min.js";
import "froala-editor/js/plugins/image.min.js";
import "froala-editor/js/plugins/quote.min.js";
import "froala-editor/js/plugins/colors.min.js";
import "froala-editor/js/plugins/draggable.min.js";
import "froala-editor/js/plugins/char_counter.min.js";
import "froala-editor/js/plugins/fullscreen.min.js";
import "froala-editor/js/plugins/font_size.min.js";
import "froala-editor/js/plugins/image_manager.min.js";
import "froala-editor/js/third_party/image_tui.min.js";
import "froala-editor/js/plugins/lists.min.js";
import "froala-editor/js/plugins/table.min.js";
import "froala-editor/js/plugins/code_beautifier.min.js";
import "froala-editor/js/plugins/font_family.min.js";
import "froala-editor/js/plugins/line_height.min.js";
import "froala-editor/js/plugins/print.min.js";
import "froala-editor/js/plugins/word_counter.min.js";
import "froala-editor/js/third_party/embedly.min.js";
import "froala-editor/js/plugins/track_changes.min.js";
import 'froala-editor/js/plugins/find_and_replace.min.js';
import "froala-editor/js/plugins/link.min.js";
import "froala-editor/js/plugins/quick_insert.min.js";
import "froala-editor/js/plugins/video.min.js";

// Import custom mentions plugin
import "./froala-mentions-plugin";

window.FroalaEditor = FroalaEditor;
export default true;
